

export const index = 3;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/games/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/3.BvnGjiDa.js","_app/immutable/chunks/disclose-version.Dr32KdXi.js","_app/immutable/chunks/index-client.7IhS7CEJ.js","_app/immutable/chunks/legacy.DQ3C9O0k.js","_app/immutable/chunks/index.D2vQXN-9.js","_app/immutable/chunks/index.xUn_SZbm.js"];
export const stylesheets = ["_app/immutable/assets/fa-layers-text.DdWHEj6G.css"];
export const fonts = [];
